import { createAsyncThunk } from '@reduxjs/toolkit';
import { promoCodeService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';
import { CreatePromoCodeRequest, UpdatePromoCodeRequest } from '../../../types/promoCodes';

export const fetchPromoCodes = createAsyncThunk('promoCode/fetch-all', (data: PaginatedRequest) =>
  promoCodeService.fetchPromoCodes(data),
);

export const createPromoCode = createAsyncThunk('promoCode/create', (promoCode: CreatePromoCodeRequest) =>
  promoCodeService.createPromoCode(promoCode),
);

export const updatePromoCode = createAsyncThunk('promoCode/update', (promoCode: UpdatePromoCodeRequest) =>
  promoCodeService.updatePromoCode(promoCode),
);

export const fetchPromoCodeUsages = createAsyncThunk('promoCode/fetch-usages', (data: PaginatedRequest) =>
  promoCodeService.fetchPromoCodeUsages(data),
);
